import { render, staticRenderFns } from "./Simulator.vue?vue&type=template&id=1890a86c&scoped=true"
import script from "./Simulator.vue?vue&type=script&lang=js"
export * from "./Simulator.vue?vue&type=script&lang=js"
import style0 from "./Simulator.vue?vue&type=style&index=0&id=1890a86c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1890a86c",
  null
  
)

export default component.exports